export default __webpack_public_path__ + "images/bd251eb1a37268a2385dfb87930089c1-dinner_small.webp";